import template from './notAllowed.html';
import './notAllowed.scss';

let notAllowedComponent = {
  restrict: 'E',
  bindings: {},
  template,
};

export default notAllowedComponent;



// WEBPACK FOOTER //
// ./client/app/features/notAllowed/notAllowed.component.js